var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart wishlist"},[_c('a',{staticClass:"icon-cart-link",attrs:{"href":_vm.clickThrough}},[_c('i',{staticClass:"icon icon-star"}),_vm._v(" "),_c('div',{staticClass:"count"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.count))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }